module.exports = __webpack_public_path__ + "static/media/point1.659cdf04.png";